<groundworks-modal>
  <groundworks-modal-header
    [title]="isEditMode() ? 'Edit Utilities' : 'Add Utilities'"
    [isCancellable]="true"
    (cancelModal)="cancel()"
  />
  <groundworks-modal-body>
    <div class="mb-3">
      <label for="description" class="form-label">Description @if (!isEditMode()) {<span class="text-danger">*</span>}</label>
      <textarea
        id="description"
        class="form-control"
        rows="1"
        [ngModel]="description()"
        (ngModelChange)="description.set($event)"
        placeholder="Enter utility description."
      ></textarea>
    </div>
    <div class="mb-3">
      <label for="calledInDate" class="form-label">Date Called In @if (!isEditMode()) {<span class="text-danger">*</span>}</label>
      <div class="position-relative">
        <input
          id="calledInDate"
          type="text"
          readonly
          class="form-control pe-4"
          [value]="formatDateForDisplay(calledInDate())"
          placeholder="Enter date called in"
          [style.cursor]="'pointer'"
          (click)="toggleDatePicker('calledIn')"
        />
        <button
          type="button"
          class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-3"
          aria-label="Toggle called in date picker"
          (click)="toggleDatePicker('calledIn')"
        >
          <i class="bi bi-calendar-check"></i>
        </button>
        @if (showCalledInDatePicker()) {
        <div class="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg z-1000">
          <groundworks-date-picker
            [isRangeSelection]="false"
            [displayMonths]="1"
            [selectedDate]="calledInDateAsDate()"
            (fromDateEvent)="handleDateSelected('calledIn', $event)"
          />
        </div>
        }
      </div>
    </div>
    <div class="mb-3">
      <label for="digWindowStartDate" class="form-label">Dig Window @if (!isEditMode()) {<span class="text-danger">*</span>}</label>
      <div class="d-flex gap-2">
        <div class="position-relative flex-fill">
          <input
            id="digWindowStartDate"
            type="text"
            readonly
            class="form-control pe-4"
            [value]="formatDateForDisplay(digWindowStartDate())"
            placeholder="Enter start date"
            [style.cursor]="'pointer'"
            (click)="toggleDatePicker('digStart')"
          />
          <button
            type="button"
            class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-3"
            aria-label="Toggle dig window start date picker"
            (click)="toggleDatePicker('digStart')"
          >
            <i class="bi bi-calendar-check"></i>
          </button>
          @if (showDigWindowStartDatePicker()) {
          <div class="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg z-1000">
            <groundworks-date-picker
              [isRangeSelection]="false"
              [displayMonths]="1"
              [selectedDate]="digWindowStartDateAsDate()"
              (fromDateEvent)="handleDateSelected('digStart', $event)"
            />
          </div>
          }
        </div>
        <div class="position-relative flex-fill">
          <input
            id="digWindowEndDate"
            type="text"
            readonly
            class="form-control pe-4"
            [class.border-danger]="showDigWindowError()"
            [value]="formatDateForDisplay(digWindowEndDate())"
            placeholder="Enter end date"
            [style.cursor]="'pointer'"
            (click)="toggleDatePicker('digEnd')"
          />
          <button
            type="button"
            class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-3"
            aria-label="Toggle dig window end date picker"
            (click)="toggleDatePicker('digEnd')"
          >
            <i class="bi bi-calendar-check"></i>
          </button>
          @if (showDigWindowEndDatePicker()) {
          <div class="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg z-1000">
            <groundworks-date-picker
              [isRangeSelection]="false"
              [displayMonths]="1"
              [selectedDate]="digWindowEndDateAsDate()"
              (fromDateEvent)="handleDateSelected('digEnd', $event)"
            />
          </div>
          }
        </div>
      </div>
    </div>
    <div class="mb-3">
      <label for="confirmationNumber" class="form-label">Confirmation Number</label>
      <input
        id="confirmationNumber"
        type="text"
        class="form-control"
        [ngModel]="confirmationNumber()"
        (ngModelChange)="confirmationNumber.set($event)"
        placeholder="Enter confirmation number."
      />
    </div>
  </groundworks-modal-body>
  @if (showDigWindowError()) {
  <div class="text-danger small px-3 pb-2">End date cannot be before start date.</div>
  }
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
